import PropTypes from 'prop-types';
import cx from 'classnames';
import { ArticleCard, Carousel } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter} from '@bwoty-web/ui-kit/hooks';

import './cruiseShipListContainer.scss';

const CruiseShipListContainer = ({ cruiseShips }) => {
  const isGlobetrotter = useIsGlobetrotter();
  const imageAspectRatio = isGlobetrotter ? 2 / 3 : 3 / 2;
  const itemSize = isGlobetrotter ? 3 : 4;
 
  return (
      <Carousel itemSize={itemSize}>
        {cruiseShips?.map((cruiseShip) => {
          const url = `/${cruiseShip?.cruiseShipLink}`;
          return (
            <ArticleCard
              columnSpan={3}
              image={{
                cloudinaryUriTemplate:
                  cruiseShip?.shipImage?.cloudinaryUriTemplate,
              }}
              imageAspectRatio={imageAspectRatio}
              key={cruiseShip?.id}
              title={
                <span
                  className={cx('iw-cruise-ship-list-headline', {
                    'iw-cruise-ship-list-headline--globe': isGlobetrotter,
                  })
                }
                >
                  {cruiseShip?.cruiseShipName}
                </span>
              }
              url={url}
            />
          );
        })}
      </Carousel>
  );
};

CruiseShipListContainer.propTypes = {
  cruiseShips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      shipImage: PropTypes.shape({
        cloudinaryUriTemplate: PropTypes.string,
      }),
      cruiseShipName: PropTypes.string.isRequired,
      cruiseShipLink: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
export default CruiseShipListContainer;
